import { SPACE } from "./sidebarVisual";

/**
 * Shared visual tokens for V2 Company Details header.
 * Keep the overview almost monochromatic; purple is interaction-only.
 * Spacing uses the same SPACE scale as tab content.
 */
export const HEADER = {
  iconSize: 15,
  /** Company logo in the identity row — larger than meta icons for hierarchy. */
  logoSize: 44,
  border: "1px solid rgba(88, 89, 91, 0.18)",
  divider: "1px solid rgba(88, 89, 91, 0.14)",
  /**
   * Full-width tab rail under the fixed overview.
   * Stronger than `divider` so fixed vs dynamic content reads clearly.
   */
  tabRail: {
    height: 2,
    color: "rgba(88, 89, 91, 0.32)",
  },
  /** Active tab indicator sitting on the rail (primary purple via sx). */
  tabIndicator: {
    height: 2.5,
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 13,
    lineHeight: 1.3,
  },
  /** Between major information groups — aligned to SPACE scale. */
  gap: {
    // Clear break between identity (logo/name) and description / tags.
    identityToLinks: 4, // 32px — title → description
    linksToDescription: SPACE.lg, // 16px (legacy; links row removed)
    descriptionToChips: SPACE.lg, // 16px — description + tags as one overview group
    chipsToTabs: SPACE.xl, // 20px
    withinGroup: SPACE.sm, // 8px
    iconText: 0.6, // ~5px
    socialIcons: SPACE.sm, // 8px
    socialToWebsite: SPACE.md, // 12px
    logoText: SPACE.md, // 12px
  },
};
